var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleFilters = function SvgCircleFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#DDDBFF",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.4 15c0 1.05-.674 1.942-1.612 2.268l.007.039.005.093v4.8a.8.8 0 0 1-1.595.093L11.2 22.2v-4.8q0-.068.011-.133a2.4 2.4 0 0 1 .001-4.535l-.007-.039-.005-.093V7.8a.8.8 0 0 1 1.595-.093l.005.093v4.8q0 .068-.011.133A2.4 2.4 0 0 1 14.4 15m-1.6 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0M20 9.4c0 1.05-.674 1.942-1.612 2.268l.007.039.005.093v10.4a.8.8 0 0 1-1.595.093L16.8 22.2V11.8q0-.068.011-.133A2.4 2.4 0 1 1 20 9.4m-1.6 0a.8.8 0 1 0-1.6 0 .8.8 0 0 0 1.6 0"
  })));
};
export default SvgCircleFilters;